import { render, staticRenderFns } from "./LosePayoutForm.vue?vue&type=template&id=73b60854&"
import script from "./LosePayoutForm.vue?vue&type=script&lang=js&"
export * from "./LosePayoutForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports